<script lang="ts">
  import { PathsPage, type Response } from '@glimja/storefront/pages/collections';
  import type { Snippet } from 'svelte';

  const { data, children }: { data: Response; children?: Snippet } = $props();
</script>

<PathsPage data={data}>
  {@render children?.()}
</PathsPage>
